import React from "react";
import { Link } from 'react-router-dom';
     
export default function MobileMenu() {
    return(
        <div
  id="ltn__utilize-mobile-menu"
  className="ltn__utilize ltn__utilize-mobile-menu"
>
  <div className="ltn__utilize-menu-inner ltn__scrollbar">
    <div className="ltn__utilize-menu-head">
      <div className="site-logo">
        <a href="index.html">
          <img src="img/logo.png" alt="Logo" />
        </a>    
      </div>
      <button className="ltn__utilize-close">×</button>
    </div>
    <div className="ltn__utilize-menu-search-form">
      <form action="#">
        <input type="text" placeholder="Search..." />
        <button>
          <i className="fas fa-search" />
        </button>
      </form>
    </div>
    <div className="ltn__utilize-menu">
      <ul>
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="/about">About</a>
          <ul className="sub-menu">
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/team">Team</a>
            </li>
          </ul>
        </li>
        <li>
           <Link to="/service">Service</Link>
        </li>
        <li>
          <a href="/shop">Shop</a>
          <ul className="sub-menu">
            <li>
              <a href="/shop">Shop</a>
            </li>
            <li>
              <a href="/cart">Cart</a>
            </li>
            <li>
              <a href="/wishlist">Wishlist</a>
            </li>
            <li>
              <a href="/checkout">Checkout</a>
            </li>
            <li>
              <a href="/order-tracking">Order Tracking </a>
            </li>
          </ul>
        </li>
        
        <li>
          <a href="/contact">Contact</a>
        </li>
      </ul>
    </div>
    <div className="ltn__utilize-buttons ltn__utilize-buttons-2">
      <ul>
        <li>
          <a href="/account" title="My Account">
            <span className="utilize-btn-icon">
              <i className="far fa-user" />
            </span>
            My Account
          </a>
        </li>
        <li>
          <a href="/wishlist" title="Wishlist">
            <span className="utilize-btn-icon">
              <i className="far fa-heart" />
              <sup>3</sup>
            </span>
            Wishlist
          </a>
        </li>
        <li>
          <a href="/cart" title="Shoping Cart">
            <span className="utilize-btn-icon">
              <i className="fas fa-shopping-cart" />
              <sup>5</sup>
            </span>
            Shoping Cart
          </a>
        </li>
      </ul>
    </div>
    <div className="ltn__social-media-2">
      <ul>
        <li>
          <a href="#" title="Facebook">
            <i className="fab fa-facebook-f" />
          </a>
        </li>
        <li>
          <a href="#" title="Twitter">
            <i className="fab fa-twitter" />
          </a>
        </li>
        <li>
          <a href="#" title="Linkedin">
            <i className="fab fa-linkedin" />
          </a>
        </li>
        <li>
          <a href="#" title="Instagram">
            <i className="fab fa-instagram" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

    );

}